import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { chatModalState, lastBrainResponseResolveSelector, skipSurveyState, } from '@/state/session';
import { isCustomSurveyEvent } from '@/util/utils';
import { WebviewResponse } from './Webview/WebviewResponse';
export const Survey = ({ survey, onButtonClick }) => {
    const setChatModal = useSetRecoilState(chatModalState);
    const setSkipSurvey = useSetRecoilState(skipSurveyState);
    const isCustomSurvey = isCustomSurveyEvent(survey);
    const lastResponseResolves = useRecoilValue(lastBrainResponseResolveSelector);
    const alreadyShown = useRef(false);
    useEffect(() => {
        if (isCustomSurvey) {
            setSkipSurvey(true);
            // If the latest brain response is not a resolve, show the survey.
            // This is to show the survey AFTER the resolved modal has been displayed.
        }
        else if (!lastResponseResolves && !alreadyShown.current) {
            setChatModal("survey" /* ChatModal.Survey */);
        }
        alreadyShown.current = true;
    }, [
        survey,
        setChatModal,
        setSkipSurvey,
        isCustomSurvey,
        lastResponseResolves,
    ]);
    const handleSurveyClick = (data) => {
        onButtonClick(Object.assign(Object.assign({}, data), { type: 'survey_button' }));
    };
    if (isCustomSurvey) {
        return (_jsx(WebviewResponse, { webview: survey, onButtonClick: handleSurveyClick }));
    }
    return null;
};
